import type { TFunction } from 'i18next';

import type { WorkflowSummary, WorkflowType } from '@/api/workflows';

/**
 * Renders the workflow's assignment-type as a localized label.
 * Centralised so the three pages that show it (Workflows card, Workflow Details,
 * Approver Review) can't drift apart when a new type is added.
 */
export function assigneeLabel(type: WorkflowType, t: TFunction): string {
  switch (type) {
    case 'InternalAdvisor':
      return t('workflow.types.internal');
    case 'ExternalAdvisor':
      return t('workflow.types.external');
    case 'Both':
      return t('workflow.types.both');
  }
}

/** Convenience: read it straight off a template. */
export const assigneeOf = (w: WorkflowSummary, t: TFunction): string => assigneeLabel(w.type, t);

/**
 * Pick the French or English version of a workflow's name / description based on the
 * current i18n language. Falls back to the English value when the French one is empty
 * (matches the existing inline behaviour across pages).
 */
export function localizedName(w: WorkflowSummary, isFr: boolean): string {
  return (isFr ? w.nameFr : w.nameEn) || w.nameEn;
}

export function localizedDescription(w: WorkflowSummary, isFr: boolean): string {
  return (isFr ? w.descriptionFr : w.descriptionEn) || w.descriptionEn;
}
